import { getMediaTypeFromMimetype } from "@pathwright/media-utils"
import {
  MEDIA_TYPES,
  MEDIA_TYPE_MAP
} from "@pathwright/ux/src/components/filestack/constants"
import {
  getHumanFileSize,
  getOptions
} from "@pathwright/ux/src/components/filestack/utils"
import lowerCase from "lodash/lowerCase"

export const submissionToAttachment = (submission = {}) => {
  const { filename, type, size, ...attachmentFields } = submission

  return {
    ...attachmentFields,
    name: filename || submission.url,
    mediaType: type,
    fileSize: size
  }
}

export const fileToSubmission = (file) => {
  const { url, filename, mimetype, size, handle } = file

  return {
    filestackHandle: handle,
    size,
    filename,
    url,
    createdDate: new Date().getTime(),
    type: getMediaTypeFromMimetype(mimetype),
    mimetype
  }
}

export const linkToSubmission = (url) => {
  return {
    filestackHandle: "",
    filename: url,
    url,
    createdDate: new Date().getTime(),
    type: MEDIA_TYPES.LINK,
    mimetype: ""
  }
}

// When choosing allowed file type in submit block,
//  reset existing submission if it doesn't match the allowed type
export const handleSubmitFileTypeChange = (value, existingSubmission) => {
  const change = { allowedType: value }

  if (
    existingSubmission &&
    existingSubmission.type !== value &&
    value !== MEDIA_TYPES.ANY
  ) {
    change.submission = null
  }

  return change
}

export const getAllowedFileOptions = (t) => {
  return Object.keys(MEDIA_TYPE_MAP)
    .filter(
      (mediaType) =>
        mediaType !== MEDIA_TYPES.FILE &&
        mediaType !== MEDIA_TYPES.ARCHIVE &&
        mediaType !== MEDIA_TYPES.DOCUMENT
    )
    .map((mediaType) => {
      const value = mediaType
      const label = t(`media.types.${lowerCase(mediaType)}.label`)

      return {
        value,
        label
      }
    })
}

export const getUploaderMessage = (mediaType, { includeSize, t }) => {
  let message
  const { maxSize } = getOptions(mediaType)
  const size = getHumanFileSize(maxSize)

  if (mediaType === MEDIA_TYPES.FILE || mediaType === MEDIA_TYPES.ANY) {
    message = t("blocks.submit.upload_any")
  } else if (mediaType === MEDIA_TYPES.LINK) {
    message = t("blocks.submit.add_link")
  } else {
    message = `${t("blocks.submit.upload")} ${t(
      `media.types.${lowerCase(mediaType)}.label_plural`
    )}`
  }

  if (includeSize && mediaType !== MEDIA_TYPES.LINK) {
    message = `${message} ${t("blocks.submit.up_to")} ${size}.`
  }

  return message
}

export const getSubmitPromptMessage = (mediaType, t) => {
  const messageWithSize =
    mediaType === MEDIA_TYPES.LINK
      ? t("blocks.submit.links_message")
      : getUploaderMessage(mediaType || MEDIA_TYPES.ANY, {
          includeSize: true,
          t
        })

  return normalizeHTML(messageWithSize)
}

export const normalizeHTML = (testString = "") => {
  const htmlWrapped = testString.startsWith("<p>")
    ? testString
    : "<p>" + testString + "</p>"

  // NOTE: using replace and not replaceAll as replaceAll is not supported
  // in older browser versions (which we don't support, but we'll acquiesce)
  return htmlWrapped.replace(/\n/g, "<br />")
}
